module.exports = {
	"contractName": "CredentialsStore",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "credentialId",
					"type": "uint256"
				}
			],
			"name": "find",
			"outputs": [
				{
					"name": "issuer",
					"type": "bytes32"
				},
				{
					"name": "recipient",
					"type": "bytes32"
				},
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "imageHash",
					"type": "bytes"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "Credentials",
			"outputs": [
				{
					"name": "sender",
					"type": "address"
				},
				{
					"name": "issuer",
					"type": "bytes32"
				},
				{
					"name": "recipient",
					"type": "bytes32"
				},
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "imageHash",
					"type": "bytes"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "status",
					"type": "bytes32"
				}
			],
			"name": "getCredentialsByStatusCount",
			"outputs": [
				{
					"name": "count",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "issuer",
					"type": "bytes32"
				},
				{
					"name": "recipient",
					"type": "bytes32"
				},
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "imageHash",
					"type": "bytes"
				}
			],
			"name": "save",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "i",
					"type": "uint256"
				}
			],
			"name": "getCredentialIdByStatus",
			"outputs": [
				{
					"name": "credentialId",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "credentialIdsByStatus",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "lastCredentialId",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_sender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_credentialId",
					"type": "uint256"
				}
			],
			"name": "NewCredentialStored",
			"type": "event"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "56:2399:0:-;;;784:103;;;;;;;;849:1;830:16;:20;;;;869:10;861:5;;:18;;;;;;;;;;;;;;;;;;56:2399;;;;;;",
	"deployedSourceMap": "56:2399:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1722:321;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;517:50:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2097:151;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;923:759;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;341:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2289:161;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;452:56;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;412:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1722:321;1779:14;1805:17;1834:14;1860:15;;:::i;:::-;1888;1906:11;:25;1918:12;1906:25;;;;;;;;;;;1888:43;;1950:11;:18;;;1970:11;:21;;;1993:11;:18;;;2013:11;:21;;1942:93;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1722:321;;;;;;:::o;517:50::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;2097:151::-;2171:13;2204:21;:29;2226:6;2204:29;;;;;;;;;;;;;;;;;:36;;;;2197:43;;2097:151;;;:::o;923:759::-;1125:20;1110:1;1097:14;;:6;1104:1;1097:9;;;;;;;;;;;;:14;;;;;1089:23;;;;;;;;1150:16;;1148:18;;;;;;;;;;1125:41;;1266:10;1231:11;:25;1243:12;1231:25;;;;;;;;;;;:32;;;:45;;;;;;;;;;;;;;;;;;1322:6;1287:11;:25;1299:12;1287:25;;;;;;;;;;;:32;;:41;;;;;;;1377:9;1339:11;:25;1351:12;1339:25;;;;;;;;;;;:35;;:47;;;;;;;1432:6;1397:11;:25;1409:12;1397:25;;;;;;;;;;;:32;;:41;;;;;;;1487:9;1449:11;:25;1461:12;1449:25;;;;;;;;;;;:35;;:47;;;;;;;;;;;;:::i;:::-;;1546:21;:29;1568:6;1546:29;;;;;;;;;;;;;;;;;:48;;;;;;;;;;;:::i;:::-;;;;;;;;;;1581:12;1546:48;;;;;;;1627:11;:25;1639:12;1627:25;;;;;;;;;;;:32;;;;;;;;;;;;1607:67;;;1661:12;1607:67;;;;;;;;;;;;;;;;;;923:759;;;;;:::o;341:20::-;;;;;;;;;;;;;:::o;2289:161::-;2370:20;2410:21;:29;2432:6;2410:29;;;;;;;;;;;;;;;;;2440:1;2410:32;;;;;;;;;;;;;;;;;;;2403:39;;2289:161;;;;:::o;452:56::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;412:31::-;;;;:::o;56:2399::-;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.16;\r\n\r\nimport './SafeMath.sol';\r\n\r\ncontract CredentialsStore {\r\n    \r\n    using SafeMath for uint256;\r\n\r\n    //structure to store credentials\r\n    struct credential {\r\n    address sender;\r\n    bytes32 issuer;\r\n    bytes32 recipient;\r\n    bytes32 status;\r\n    bytes imageHash;\r\n    }\r\n\r\n    //address of owner/admin\r\n    address public owner;\r\n    //variable to store last credential ID\r\n    uint256 public lastCredentialId;\r\n\r\n    mapping (bytes32 => uint[]) public credentialIdsByStatus;\r\n\r\n    mapping (uint256 => credential) public Credentials;\r\n\r\n    //fire when credential is stored\r\n    event NewCredentialStored(address indexed _sender, uint256 _credentialId);\r\n\r\n    modifier onlyOwner() {\r\n        require(msg.sender == owner);\r\n        _;\r\n    }\r\n\r\n    function CredentialsStore() public {\r\n        lastCredentialId = 0;\r\n        owner = msg.sender;\r\n    }\r\n\r\n    // save the Credential\r\n    function save(bytes32 issuer, bytes32 recipient, bytes32 status, bytes imageHash) public {\r\n        // check status not null, important for indexation later\r\n        require(status[0] != 0);\r\n\r\n        uint256 credentialId = ++lastCredentialId;\r\n        // add credential to the credentials mapping\r\n        Credentials[credentialId].sender = msg.sender;\r\n        Credentials[credentialId].issuer = issuer;\r\n        Credentials[credentialId].recipient = recipient;\r\n        Credentials[credentialId].status = status;\r\n        Credentials[credentialId].imageHash = imageHash;\r\n        // index credential by status\r\n        credentialIdsByStatus[status].push(credentialId);\r\n\r\n        NewCredentialStored(Credentials[credentialId].sender, credentialId);\r\n    }\r\n\r\n    // find a credential by id\r\n    function find(uint256 credentialId) view public returns (bytes32 issuer, \r\n        bytes32 recipient, \r\n        bytes32 status, \r\n        bytes imageHash) {\r\n        var _credential = Credentials[credentialId];\r\n        return (_credential.issuer, _credential.recipient, _credential.status, _credential.imageHash);\r\n    }\r\n\r\n    // get number of credentials in a status\r\n    function getCredentialsByStatusCount(bytes32 status) view public returns (uint256 count) {\r\n        return credentialIdsByStatus[status].length;\r\n    }\r\n\r\n    // get credential by status\r\n    function getCredentialIdByStatus(bytes32 status, uint256 i) view public returns (uint256 credentialId) {\r\n        return credentialIdsByStatus[status][i];\r\n    }\r\n\r\n}",
	"sourcePath": "/Users/sarthak/dltlabs/echolink-code/contracts/CredentialsStore.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/CredentialsStore.sol",
			"exportedSymbols": {
				"CredentialsStore": [
					194
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 1,
				"name": "PragmaDirective",
				"src": "0:24:0"
			},
			{
				"attributes": {
					"SourceUnit": 1963,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/SafeMath.sol",
					"file": "./SafeMath.sol",
					"scope": 195,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 2,
				"name": "ImportDirective",
				"src": "28:24:0"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						194
					],
					"name": "CredentialsStore",
					"scope": 195
				},
				"children": [
					{
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "SafeMath",
									"referencedDeclaration": 1962,
									"type": "library SafeMath"
								},
								"id": 3,
								"name": "UserDefinedTypeName",
								"src": "101:8:0"
							},
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 4,
								"name": "ElementaryTypeName",
								"src": "114:7:0"
							}
						],
						"id": 5,
						"name": "UsingForDirective",
						"src": "95:27:0"
					},
					{
						"attributes": {
							"canonicalName": "CredentialsStore.credential",
							"name": "credential",
							"scope": 194,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"constant": false,
									"name": "sender",
									"scope": 16,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "address",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 6,
										"name": "ElementaryTypeName",
										"src": "193:7:0"
									}
								],
								"id": 7,
								"name": "VariableDeclaration",
								"src": "193:14:0"
							},
							{
								"attributes": {
									"constant": false,
									"name": "issuer",
									"scope": 16,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bytes32",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 8,
										"name": "ElementaryTypeName",
										"src": "214:7:0"
									}
								],
								"id": 9,
								"name": "VariableDeclaration",
								"src": "214:14:0"
							},
							{
								"attributes": {
									"constant": false,
									"name": "recipient",
									"scope": 16,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bytes32",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 10,
										"name": "ElementaryTypeName",
										"src": "235:7:0"
									}
								],
								"id": 11,
								"name": "VariableDeclaration",
								"src": "235:17:0"
							},
							{
								"attributes": {
									"constant": false,
									"name": "status",
									"scope": 16,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bytes32",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 12,
										"name": "ElementaryTypeName",
										"src": "259:7:0"
									}
								],
								"id": 13,
								"name": "VariableDeclaration",
								"src": "259:14:0"
							},
							{
								"attributes": {
									"constant": false,
									"name": "imageHash",
									"scope": 16,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bytes storage pointer",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes",
											"type": "bytes storage pointer"
										},
										"id": 14,
										"name": "ElementaryTypeName",
										"src": "280:5:0"
									}
								],
								"id": 15,
								"name": "VariableDeclaration",
								"src": "280:15:0"
							}
						],
						"id": 16,
						"name": "StructDefinition",
						"src": "168:135:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "owner",
							"scope": 194,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "address",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "address",
									"type": "address"
								},
								"id": 17,
								"name": "ElementaryTypeName",
								"src": "341:7:0"
							}
						],
						"id": 18,
						"name": "VariableDeclaration",
						"src": "341:20:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "lastCredentialId",
							"scope": 194,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 19,
								"name": "ElementaryTypeName",
								"src": "412:7:0"
							}
						],
						"id": 20,
						"name": "VariableDeclaration",
						"src": "412:31:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "credentialIdsByStatus",
							"scope": 194,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(bytes32 => uint256[] storage ref)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(bytes32 => uint256[] storage ref)"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 21,
										"name": "ElementaryTypeName",
										"src": "461:7:0"
									},
									{
										"attributes": {
											"length": null,
											"type": "uint256[] storage pointer"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 22,
												"name": "ElementaryTypeName",
												"src": "472:4:0"
											}
										],
										"id": 23,
										"name": "ArrayTypeName",
										"src": "472:6:0"
									}
								],
								"id": 24,
								"name": "Mapping",
								"src": "452:27:0"
							}
						],
						"id": 25,
						"name": "VariableDeclaration",
						"src": "452:56:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "Credentials",
							"scope": 194,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)"
								},
								"children": [
									{
										"attributes": {
											"name": "uint256",
											"type": "uint256"
										},
										"id": 26,
										"name": "ElementaryTypeName",
										"src": "526:7:0"
									},
									{
										"attributes": {
											"contractScope": null,
											"name": "credential",
											"referencedDeclaration": 16,
											"type": "struct CredentialsStore.credential storage pointer"
										},
										"id": 27,
										"name": "UserDefinedTypeName",
										"src": "537:10:0"
									}
								],
								"id": 28,
								"name": "Mapping",
								"src": "517:31:0"
							}
						],
						"id": 29,
						"name": "VariableDeclaration",
						"src": "517:50:0"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "NewCredentialStored"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": true,
											"name": "_sender",
											"scope": 35,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 30,
												"name": "ElementaryTypeName",
												"src": "640:7:0"
											}
										],
										"id": 31,
										"name": "VariableDeclaration",
										"src": "640:23:0"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_credentialId",
											"scope": 35,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 32,
												"name": "ElementaryTypeName",
												"src": "665:7:0"
											}
										],
										"id": 33,
										"name": "VariableDeclaration",
										"src": "665:21:0"
									}
								],
								"id": 34,
								"name": "ParameterList",
								"src": "639:48:0"
							}
						],
						"id": 35,
						"name": "EventDefinition",
						"src": "614:74:0"
					},
					{
						"attributes": {
							"name": "onlyOwner",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 36,
								"name": "ParameterList",
								"src": "714:2:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 37,
														"name": "Identifier",
														"src": "728:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "==",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 38,
																		"name": "Identifier",
																		"src": "736:3:0"
																	}
																],
																"id": 39,
																"name": "MemberAccess",
																"src": "736:10:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 18,
																	"type": "address",
																	"value": "owner"
																},
																"id": 40,
																"name": "Identifier",
																"src": "750:5:0"
															}
														],
														"id": 41,
														"name": "BinaryOperation",
														"src": "736:19:0"
													}
												],
												"id": 42,
												"name": "FunctionCall",
												"src": "728:28:0"
											}
										],
										"id": 43,
										"name": "ExpressionStatement",
										"src": "728:28:0"
									},
									{
										"id": 44,
										"name": "PlaceholderStatement",
										"src": "767:1:0"
									}
								],
								"id": 45,
								"name": "Block",
								"src": "717:59:0"
							}
						],
						"id": 46,
						"name": "ModifierDefinition",
						"src": "696:80:0"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "CredentialsStore",
							"payable": false,
							"scope": 194,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 47,
								"name": "ParameterList",
								"src": "809:2:0"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 48,
								"name": "ParameterList",
								"src": "819:0:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 20,
															"type": "uint256",
															"value": "lastCredentialId"
														},
														"id": 49,
														"name": "Identifier",
														"src": "830:16:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 50,
														"name": "Literal",
														"src": "849:1:0"
													}
												],
												"id": 51,
												"name": "Assignment",
												"src": "830:20:0"
											}
										],
										"id": 52,
										"name": "ExpressionStatement",
										"src": "830:20:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 18,
															"type": "address",
															"value": "owner"
														},
														"id": 53,
														"name": "Identifier",
														"src": "861:5:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 54,
																"name": "Identifier",
																"src": "869:3:0"
															}
														],
														"id": 55,
														"name": "MemberAccess",
														"src": "869:10:0"
													}
												],
												"id": 56,
												"name": "Assignment",
												"src": "861:18:0"
											}
										],
										"id": 57,
										"name": "ExpressionStatement",
										"src": "861:18:0"
									}
								],
								"id": 58,
								"name": "Block",
								"src": "819:68:0"
							}
						],
						"id": 59,
						"name": "FunctionDefinition",
						"src": "784:103:0"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "save",
							"payable": false,
							"scope": 194,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "issuer",
											"scope": 135,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 60,
												"name": "ElementaryTypeName",
												"src": "937:7:0"
											}
										],
										"id": 61,
										"name": "VariableDeclaration",
										"src": "937:14:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "recipient",
											"scope": 135,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 62,
												"name": "ElementaryTypeName",
												"src": "953:7:0"
											}
										],
										"id": 63,
										"name": "VariableDeclaration",
										"src": "953:17:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "status",
											"scope": 135,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 64,
												"name": "ElementaryTypeName",
												"src": "972:7:0"
											}
										],
										"id": 65,
										"name": "VariableDeclaration",
										"src": "972:14:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "imageHash",
											"scope": 135,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes",
													"type": "bytes storage pointer"
												},
												"id": 66,
												"name": "ElementaryTypeName",
												"src": "988:5:0"
											}
										],
										"id": 67,
										"name": "VariableDeclaration",
										"src": "988:15:0"
									}
								],
								"id": 68,
								"name": "ParameterList",
								"src": "936:68:0"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 69,
								"name": "ParameterList",
								"src": "1012:0:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 70,
														"name": "Identifier",
														"src": "1089:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bytes1",
																"typeString": "bytes1"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "!=",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "bytes1"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 65,
																			"type": "bytes32",
																			"value": "status"
																		},
																		"id": 71,
																		"name": "Identifier",
																		"src": "1097:6:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 72,
																		"name": "Literal",
																		"src": "1104:1:0"
																	}
																],
																"id": 73,
																"name": "IndexAccess",
																"src": "1097:9:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 74,
																"name": "Literal",
																"src": "1110:1:0"
															}
														],
														"id": 75,
														"name": "BinaryOperation",
														"src": "1097:14:0"
													}
												],
												"id": 76,
												"name": "FunctionCall",
												"src": "1089:23:0"
											}
										],
										"id": 77,
										"name": "ExpressionStatement",
										"src": "1089:23:0"
									},
									{
										"attributes": {
											"assignments": [
												79
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "credentialId",
													"scope": 135,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint256",
															"type": "uint256"
														},
														"id": 78,
														"name": "ElementaryTypeName",
														"src": "1125:7:0"
													}
												],
												"id": 79,
												"name": "VariableDeclaration",
												"src": "1125:20:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "++",
													"prefix": true,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 20,
															"type": "uint256",
															"value": "lastCredentialId"
														},
														"id": 80,
														"name": "Identifier",
														"src": "1150:16:0"
													}
												],
												"id": 81,
												"name": "UnaryOperation",
												"src": "1148:18:0"
											}
										],
										"id": 82,
										"name": "VariableDeclarationStatement",
										"src": "1125:41:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "sender",
															"referencedDeclaration": 7,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct CredentialsStore.credential storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 29,
																			"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
																			"value": "Credentials"
																		},
																		"id": 83,
																		"name": "Identifier",
																		"src": "1231:11:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 79,
																			"type": "uint256",
																			"value": "credentialId"
																		},
																		"id": 84,
																		"name": "Identifier",
																		"src": "1243:12:0"
																	}
																],
																"id": 85,
																"name": "IndexAccess",
																"src": "1231:25:0"
															}
														],
														"id": 86,
														"name": "MemberAccess",
														"src": "1231:32:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 87,
																"name": "Identifier",
																"src": "1266:3:0"
															}
														],
														"id": 88,
														"name": "MemberAccess",
														"src": "1266:10:0"
													}
												],
												"id": 89,
												"name": "Assignment",
												"src": "1231:45:0"
											}
										],
										"id": 90,
										"name": "ExpressionStatement",
										"src": "1231:45:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bytes32"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "issuer",
															"referencedDeclaration": 9,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct CredentialsStore.credential storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 29,
																			"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
																			"value": "Credentials"
																		},
																		"id": 91,
																		"name": "Identifier",
																		"src": "1287:11:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 79,
																			"type": "uint256",
																			"value": "credentialId"
																		},
																		"id": 92,
																		"name": "Identifier",
																		"src": "1299:12:0"
																	}
																],
																"id": 93,
																"name": "IndexAccess",
																"src": "1287:25:0"
															}
														],
														"id": 94,
														"name": "MemberAccess",
														"src": "1287:32:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 61,
															"type": "bytes32",
															"value": "issuer"
														},
														"id": 95,
														"name": "Identifier",
														"src": "1322:6:0"
													}
												],
												"id": 96,
												"name": "Assignment",
												"src": "1287:41:0"
											}
										],
										"id": 97,
										"name": "ExpressionStatement",
										"src": "1287:41:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bytes32"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "recipient",
															"referencedDeclaration": 11,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct CredentialsStore.credential storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 29,
																			"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
																			"value": "Credentials"
																		},
																		"id": 98,
																		"name": "Identifier",
																		"src": "1339:11:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 79,
																			"type": "uint256",
																			"value": "credentialId"
																		},
																		"id": 99,
																		"name": "Identifier",
																		"src": "1351:12:0"
																	}
																],
																"id": 100,
																"name": "IndexAccess",
																"src": "1339:25:0"
															}
														],
														"id": 101,
														"name": "MemberAccess",
														"src": "1339:35:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 63,
															"type": "bytes32",
															"value": "recipient"
														},
														"id": 102,
														"name": "Identifier",
														"src": "1377:9:0"
													}
												],
												"id": 103,
												"name": "Assignment",
												"src": "1339:47:0"
											}
										],
										"id": 104,
										"name": "ExpressionStatement",
										"src": "1339:47:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bytes32"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "status",
															"referencedDeclaration": 13,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct CredentialsStore.credential storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 29,
																			"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
																			"value": "Credentials"
																		},
																		"id": 105,
																		"name": "Identifier",
																		"src": "1397:11:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 79,
																			"type": "uint256",
																			"value": "credentialId"
																		},
																		"id": 106,
																		"name": "Identifier",
																		"src": "1409:12:0"
																	}
																],
																"id": 107,
																"name": "IndexAccess",
																"src": "1397:25:0"
															}
														],
														"id": 108,
														"name": "MemberAccess",
														"src": "1397:32:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 65,
															"type": "bytes32",
															"value": "status"
														},
														"id": 109,
														"name": "Identifier",
														"src": "1432:6:0"
													}
												],
												"id": 110,
												"name": "Assignment",
												"src": "1397:41:0"
											}
										],
										"id": 111,
										"name": "ExpressionStatement",
										"src": "1397:41:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bytes storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "imageHash",
															"referencedDeclaration": 15,
															"type": "bytes storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct CredentialsStore.credential storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 29,
																			"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
																			"value": "Credentials"
																		},
																		"id": 112,
																		"name": "Identifier",
																		"src": "1449:11:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 79,
																			"type": "uint256",
																			"value": "credentialId"
																		},
																		"id": 113,
																		"name": "Identifier",
																		"src": "1461:12:0"
																	}
																],
																"id": 114,
																"name": "IndexAccess",
																"src": "1449:25:0"
															}
														],
														"id": 115,
														"name": "MemberAccess",
														"src": "1449:35:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 67,
															"type": "bytes memory",
															"value": "imageHash"
														},
														"id": 116,
														"name": "Identifier",
														"src": "1487:9:0"
													}
												],
												"id": 117,
												"name": "Assignment",
												"src": "1449:47:0"
											}
										],
										"id": 118,
										"name": "ExpressionStatement",
										"src": "1449:47:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "uint256",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "push",
															"referencedDeclaration": null,
															"type": "function (uint256) returns (uint256)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "uint256[] storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 25,
																			"type": "mapping(bytes32 => uint256[] storage ref)",
																			"value": "credentialIdsByStatus"
																		},
																		"id": 119,
																		"name": "Identifier",
																		"src": "1546:21:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 65,
																			"type": "bytes32",
																			"value": "status"
																		},
																		"id": 120,
																		"name": "Identifier",
																		"src": "1568:6:0"
																	}
																],
																"id": 121,
																"name": "IndexAccess",
																"src": "1546:29:0"
															}
														],
														"id": 122,
														"name": "MemberAccess",
														"src": "1546:34:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 79,
															"type": "uint256",
															"value": "credentialId"
														},
														"id": 123,
														"name": "Identifier",
														"src": "1581:12:0"
													}
												],
												"id": 124,
												"name": "FunctionCall",
												"src": "1546:48:0"
											}
										],
										"id": 125,
										"name": "ExpressionStatement",
										"src": "1546:48:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 35,
															"type": "function (address,uint256)",
															"value": "NewCredentialStored"
														},
														"id": 126,
														"name": "Identifier",
														"src": "1607:19:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": 7,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct CredentialsStore.credential storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 29,
																			"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
																			"value": "Credentials"
																		},
																		"id": 127,
																		"name": "Identifier",
																		"src": "1627:11:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 79,
																			"type": "uint256",
																			"value": "credentialId"
																		},
																		"id": 128,
																		"name": "Identifier",
																		"src": "1639:12:0"
																	}
																],
																"id": 129,
																"name": "IndexAccess",
																"src": "1627:25:0"
															}
														],
														"id": 130,
														"name": "MemberAccess",
														"src": "1627:32:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 79,
															"type": "uint256",
															"value": "credentialId"
														},
														"id": 131,
														"name": "Identifier",
														"src": "1661:12:0"
													}
												],
												"id": 132,
												"name": "FunctionCall",
												"src": "1607:67:0"
											}
										],
										"id": 133,
										"name": "ExpressionStatement",
										"src": "1607:67:0"
									}
								],
								"id": 134,
								"name": "Block",
								"src": "1012:670:0"
							}
						],
						"id": 135,
						"name": "FunctionDefinition",
						"src": "923:759:0"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "find",
							"payable": false,
							"scope": 194,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "credentialId",
											"scope": 164,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 136,
												"name": "ElementaryTypeName",
												"src": "1736:7:0"
											}
										],
										"id": 137,
										"name": "VariableDeclaration",
										"src": "1736:20:0"
									}
								],
								"id": 138,
								"name": "ParameterList",
								"src": "1735:22:0"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "issuer",
											"scope": 164,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 139,
												"name": "ElementaryTypeName",
												"src": "1779:7:0"
											}
										],
										"id": 140,
										"name": "VariableDeclaration",
										"src": "1779:14:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "recipient",
											"scope": 164,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 141,
												"name": "ElementaryTypeName",
												"src": "1805:7:0"
											}
										],
										"id": 142,
										"name": "VariableDeclaration",
										"src": "1805:17:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "status",
											"scope": 164,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 143,
												"name": "ElementaryTypeName",
												"src": "1834:7:0"
											}
										],
										"id": 144,
										"name": "VariableDeclaration",
										"src": "1834:14:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "imageHash",
											"scope": 164,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes",
													"type": "bytes storage pointer"
												},
												"id": 145,
												"name": "ElementaryTypeName",
												"src": "1860:5:0"
											}
										],
										"id": 146,
										"name": "VariableDeclaration",
										"src": "1860:15:0"
									}
								],
								"id": 147,
								"name": "ParameterList",
								"src": "1778:98:0"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												148
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "_credential",
													"scope": 164,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "struct CredentialsStore.credential storage pointer",
													"typeName": null,
													"value": null,
													"visibility": "internal"
												},
												"children": [],
												"id": 148,
												"name": "VariableDeclaration",
												"src": "1888:15:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct CredentialsStore.credential storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 29,
															"type": "mapping(uint256 => struct CredentialsStore.credential storage ref)",
															"value": "Credentials"
														},
														"id": 149,
														"name": "Identifier",
														"src": "1906:11:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 137,
															"type": "uint256",
															"value": "credentialId"
														},
														"id": 150,
														"name": "Identifier",
														"src": "1918:12:0"
													}
												],
												"id": 151,
												"name": "IndexAccess",
												"src": "1906:25:0"
											}
										],
										"id": 152,
										"name": "VariableDeclarationStatement",
										"src": "1888:43:0"
									},
									{
										"attributes": {
											"functionReturnParameters": 147
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"type": "tuple(bytes32,bytes32,bytes32,bytes storage ref)"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "issuer",
															"referencedDeclaration": 9,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 148,
																	"type": "struct CredentialsStore.credential storage pointer",
																	"value": "_credential"
																},
																"id": 153,
																"name": "Identifier",
																"src": "1950:11:0"
															}
														],
														"id": 154,
														"name": "MemberAccess",
														"src": "1950:18:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "recipient",
															"referencedDeclaration": 11,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 148,
																	"type": "struct CredentialsStore.credential storage pointer",
																	"value": "_credential"
																},
																"id": 155,
																"name": "Identifier",
																"src": "1970:11:0"
															}
														],
														"id": 156,
														"name": "MemberAccess",
														"src": "1970:21:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "status",
															"referencedDeclaration": 13,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 148,
																	"type": "struct CredentialsStore.credential storage pointer",
																	"value": "_credential"
																},
																"id": 157,
																"name": "Identifier",
																"src": "1993:11:0"
															}
														],
														"id": 158,
														"name": "MemberAccess",
														"src": "1993:18:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "imageHash",
															"referencedDeclaration": 15,
															"type": "bytes storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 148,
																	"type": "struct CredentialsStore.credential storage pointer",
																	"value": "_credential"
																},
																"id": 159,
																"name": "Identifier",
																"src": "2013:11:0"
															}
														],
														"id": 160,
														"name": "MemberAccess",
														"src": "2013:21:0"
													}
												],
												"id": 161,
												"name": "TupleExpression",
												"src": "1949:86:0"
											}
										],
										"id": 162,
										"name": "Return",
										"src": "1942:93:0"
									}
								],
								"id": 163,
								"name": "Block",
								"src": "1877:166:0"
							}
						],
						"id": 164,
						"name": "FunctionDefinition",
						"src": "1722:321:0"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getCredentialsByStatusCount",
							"payable": false,
							"scope": 194,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "status",
											"scope": 177,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 165,
												"name": "ElementaryTypeName",
												"src": "2134:7:0"
											}
										],
										"id": 166,
										"name": "VariableDeclaration",
										"src": "2134:14:0"
									}
								],
								"id": 167,
								"name": "ParameterList",
								"src": "2133:16:0"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "count",
											"scope": 177,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 168,
												"name": "ElementaryTypeName",
												"src": "2171:7:0"
											}
										],
										"id": 169,
										"name": "VariableDeclaration",
										"src": "2171:13:0"
									}
								],
								"id": 170,
								"name": "ParameterList",
								"src": "2170:15:0"
							},
							{
								"children": [
									{
										"attributes": {
											"functionReturnParameters": 170
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"member_name": "length",
													"referencedDeclaration": null,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "uint256[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 25,
																	"type": "mapping(bytes32 => uint256[] storage ref)",
																	"value": "credentialIdsByStatus"
																},
																"id": 171,
																"name": "Identifier",
																"src": "2204:21:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 166,
																	"type": "bytes32",
																	"value": "status"
																},
																"id": 172,
																"name": "Identifier",
																"src": "2226:6:0"
															}
														],
														"id": 173,
														"name": "IndexAccess",
														"src": "2204:29:0"
													}
												],
												"id": 174,
												"name": "MemberAccess",
												"src": "2204:36:0"
											}
										],
										"id": 175,
										"name": "Return",
										"src": "2197:43:0"
									}
								],
								"id": 176,
								"name": "Block",
								"src": "2186:62:0"
							}
						],
						"id": 177,
						"name": "FunctionDefinition",
						"src": "2097:151:0"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getCredentialIdByStatus",
							"payable": false,
							"scope": 194,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "status",
											"scope": 193,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 178,
												"name": "ElementaryTypeName",
												"src": "2322:7:0"
											}
										],
										"id": 179,
										"name": "VariableDeclaration",
										"src": "2322:14:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "i",
											"scope": 193,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 180,
												"name": "ElementaryTypeName",
												"src": "2338:7:0"
											}
										],
										"id": 181,
										"name": "VariableDeclaration",
										"src": "2338:9:0"
									}
								],
								"id": 182,
								"name": "ParameterList",
								"src": "2321:27:0"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "credentialId",
											"scope": 193,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 183,
												"name": "ElementaryTypeName",
												"src": "2370:7:0"
											}
										],
										"id": 184,
										"name": "VariableDeclaration",
										"src": "2370:20:0"
									}
								],
								"id": 185,
								"name": "ParameterList",
								"src": "2369:22:0"
							},
							{
								"children": [
									{
										"attributes": {
											"functionReturnParameters": 185
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "uint256[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 25,
																	"type": "mapping(bytes32 => uint256[] storage ref)",
																	"value": "credentialIdsByStatus"
																},
																"id": 186,
																"name": "Identifier",
																"src": "2410:21:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 179,
																	"type": "bytes32",
																	"value": "status"
																},
																"id": 187,
																"name": "Identifier",
																"src": "2432:6:0"
															}
														],
														"id": 188,
														"name": "IndexAccess",
														"src": "2410:29:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 181,
															"type": "uint256",
															"value": "i"
														},
														"id": 189,
														"name": "Identifier",
														"src": "2440:1:0"
													}
												],
												"id": 190,
												"name": "IndexAccess",
												"src": "2410:32:0"
											}
										],
										"id": 191,
										"name": "Return",
										"src": "2403:39:0"
									}
								],
								"id": 192,
								"name": "Block",
								"src": "2392:58:0"
							}
						],
						"id": 193,
						"name": "FunctionDefinition",
						"src": "2289:161:0"
					}
				],
				"id": 194,
				"name": "ContractDefinition",
				"src": "56:2399:0"
			}
		],
		"id": 195,
		"name": "SourceUnit",
		"src": "0:2455:0"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.18+commit.9cf6e910.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0x3dd1b04c0a5505abffdb57d7734d145af30e5a3e"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-02-22T12:09:06.973Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/CredentialsStore.json
// module id = 208
// module chunks = 0